import React, { Component, PropTypes } from 'react';
import 'whatwg-fetch';
import cloudinary from 'cloudinary-core';
import CloudinaryUtil from './../core/CloudinaryUtil';
import CloudinaryImage from './CloudinaryImage';


const LIFECYCLE_LOADING = 'loading';
const LIFECYCLE_LOADED = 'loaded';

export default class DemoImage extends Component {
  static propTypes = {
    id: PropTypes.string,
    publicId: PropTypes.string.isRequired,
    transformation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object)
    ]).isRequired,
    className: PropTypes.string,
    divClassName: PropTypes.string,
    style: PropTypes.object,
    reportImageSize: PropTypes.func,
    showDetails: PropTypes.func.isRequired,
    showButton: PropTypes.bool
  };

  static id = 1;

  constructor(props, context) {
    super(props, context);
    this.cl = props.cl || cloudinary.Cloudinary.new();
    this.cl.fromDocument();
    this.id = this.props.id || DemoImage.id++;
    this.state = { size: 0, lifecycle: LIFECYCLE_LOADING, src: '' };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.publicId != nextProps.publicId) {
      this.setState({...this.state, lifecycle: LIFECYCLE_LOADING, size: 0});
    if (this.props.reportImageSize) {
      this.props.reportImageSize(this.props.id, 0);
    }
    if (this.props.reportImageDimensions) {
      this.props.reportImageDimensions(this.props.id, 0, 0);
    }
  }
}


handleOpen(e) {
  this.props.showDetails(this.props.transformation, this.props.format, this.props.children);
  e.preventDefault();
}

headForSize(e) {
  if (this.props.reportImageSize) {
    fetch(e.target.src + '?bust', { method: 'HEAD' }).then((response) => {
      let size = parseInt(response.headers.get('Content-Length'));
      // Extract image type from the Content-Type header, e.g. image/webp or image/jpeg
      let typeResult = /image\/(.*)/.exec(response.headers.get('Content-Type'));
      let imageType = typeResult ? typeResult[1].toUpperCase() : undefined;
      this.props.reportImageSize(this.props.id, size, imageType);
      this.setState({...this.state, size: size});
  });
}
  }


handleLoad(e) {
  if (this.props.id) {
    if (this.props.reportImageDimensions) {
      this.props.reportImageDimensions(this.props.id, e.target.naturalWidth, e.target.naturalHeight);
    }
    this.headForSize(e);
  }
  this.setState({...this.state, lifecycle: LIFECYCLE_LOADED, size: 0, src: e.target.src});
if (this.props.handleComplete) {
  this.props.handleComplete(e);
}
  }

handleError(e) {
  this.headForSize(e);
  if (this.props.handleComplete) {
    this.props.handleComplete(e);
  }
}

render() {
  let transformation = this.props.transformation;

  let loader;
  let button = <a href="#" className="btn-modal" onClick={this.handleOpen} alt="View image details" style={{ zIndex: 3 }}><span className="icon-html-tag" /></a>;
  if (this.props.showButton != null && !this.props.showButton) {
    button = null;
  }
  let imageStyle = this.props.imageStyle || {};
  imageStyle = {...imageStyle, zIndex: 2 };
  if (this.state.lifecycle == LIFECYCLE_LOADING && !this.props.hideLoading) {
    let innerStyle = { position: 'absolute', width: '100%', height: '100%', backgroundImage: 'url(images/loader.gif)', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '40px auto', zIndex: 1 };
    loader = <div style={innerStyle} />;
    imageStyle.visibility = 'hidden';
  }
  const anchorUrl = this.props.anchorUrl || this.state.src;

  return (
    <div className={this.props.className || ''} style={this.props.style} ref={
      node => { this.divNode = node; }}>
      {loader}
      <a href={anchorUrl} target="_blank">
        <CloudinaryImage {...this.props}
          imageStyle={imageStyle}
          transformation={transformation}
          id={this.id}
          handleLoad={this.handleLoad}
          handleError={this.handleError} />
      </a>
      {button}
    </div>
  );
}
}



/** WEBPACK FOOTER **
 ** ./src/js/components/DemoImage.js
 **/